/**
 * Created by mateimisarca on 24/07/2018
 */

import { capitalize } from 'lodash';

export default function keyMirror(prefix, obj = {}) {
  const ret = {};
  let key;
  for (key in obj) {
    if (obj.hasOwnProperty(key)) {
      let val = key;
      if (prefix) val = `${capitalize(prefix)}${capitalize(key)}`;
      ret[key] = val;
    }
  }
  return ret;
}
